import {Navbar} from "../../../Components/Navbar/Navbar";
import {Footer} from "../../../Components/Footer/footer";

export function BibliotecaVirtualaPage() {
    return (
        <div className="page-container">
            <Navbar/>
            <div className={"page-content"}>
                <h1>Biblioteca Virtuala</h1>
                <p>Biblioteca Virtuala</p>
            </div>
            <Footer/>
        </div>
    )
}